import {makeStyles} from "tss-react/mui";

export const useFileIconStyles = makeStyles()((theme, {dense}={}) => ({
  fileIcon: {
    width: dense ? "unset" : "100%",
    height: 60,
  },
}));
